<template>
	<div class="margin-left">
		<div class="from">
			<el-form :model="rise" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
				<el-form-item label="抬头选择" prop="capacity">
					<el-select v-model="rise.capacity" placeholder="请选择抬头">
						<el-option label="企业" :value="2"></el-option>
						<el-option label="个人" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="开票对象" prop="name">
					<el-input v-model="rise.name" :placeholder="rise.capacity == 2?'请输入企业全称':'请输入真实姓名'"></el-input>
				</el-form-item>
				<el-form-item label="执照号码" prop="number" v-if="rise.capacity == 2">
					<el-input v-model="rise.number" placeholder="请输入营业执照社会信用代码"></el-input>
				</el-form-item>
				<el-form-item label="发票类型" prop="type">
					<div v-if="rise.capacity == 1">
						<el-input v-model="rise.type" value="增值税普通发票(电子)" disabled  placeholder="增值税普通发票(电子)"></el-input>
					</div>
					<el-select v-model="rise.type" placeholder="请选择发票类型" v-if="rise.capacity != 1">
						<el-option label="增值税专用发票（纸质）" :value="2"></el-option>
						<el-option label="增值税普通发票(电子)" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<div v-if="rise.capacity == 2&&rise.type == 2">
					<el-form-item label="开户银行" prop="bank">
					  <el-input v-model="rise.bank" placeholder="请输入开户银行全称"></el-input>
					</el-form-item>
					<el-form-item label="银行账号" prop="banknum">
					  <el-input v-model="rise.banknum" placeholder="请输入银行账号"></el-input>
					</el-form-item>
					<el-form-item label="注册地址" prop="address">
					  <el-input v-model="rise.address" placeholder="请输入注册地址"></el-input>
					</el-form-item>
					<el-form-item label="注册电话" prop="phone">
					  <el-input v-model="rise.phone" placeholder="请输入注册电话"></el-input>
					</el-form-item>
				</div>
				<el-form-item>
				    <el-button type="primary" @click="submitForm('ruleForm')">确认创建</el-button>
				  </el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			//检测抬头选择
			var validateCapacity = (rule, value, callback)=>{
				console.log('检测抬头选择',rule, value);
				if (!value) {
					return callback(new Error('请选择抬头'));
				}
					callback();
			}
			//检测开票对象
			var validateName = (rule, value, callback)=>{
				if (!value) {
					return callback(new Error('开票对象不能为空'));
				}
					callback();
			}
			//检测营业执照
			var validateNumber = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请输入营业执照社会信用代码'));
					}
					callback();
				}
				callback();
			}
			//检测发票类型
			var validateType = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请选择发票类型'));
					}
					callback();
				}
				callback();
				
			}
			//检测开户银行
			var validateBank = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请输入开户银行'));
					}
					callback();
				}
				callback();
			}
			//检测银行账号
			var validateBanknum = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请输入银行账号'));
					}
					callback();
				}
				callback();
			}
			//检测注册地址
			var validateAddress = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请输入注册地址'));
					}
					callback();
				}
				callback();
			}
			//检测注册电话
			var validatePhone = (rule, value, callback)=>{
				if(this.rise.capacity == 2){
					if (!value) {
						return callback(new Error('请输入注册电话'));
					}
					callback();
				}
				callback();
			}
			return {
				rise:{
					capacity:'',//抬头选择
					name:'',//开票对象
					number:'',//执照号码
					type:'',//发票类型
					bank:'',//开户银行
					banknum:'',//银行账号
					address:'',//注册地址
					phone:'',//注册电话
				},
				id:0,//修改的id
				rules: {
					capacity: [{
							 validator: validateCapacity,
							 trigger: 'change'
						 }],
					name: [{
						validator: validateName,
						trigger: 'blur'
					}],
					number: [{
						validator: validateNumber,
						trigger: 'blur'
					}],
					type: [{
						validator: validateType,
						trigger: 'blur'
					}],
					bank:[{
						validator: validateBank,
						trigger: 'blur'
					}],
					banknum:[{
						validator: validateBanknum,
						trigger: 'blur'
					}],
					address:[{
						validator: validateAddress,
						trigger: 'blur'
					}],
					phone:[{
						validator: validatePhone,
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			Bus.$on('edit',(data)=>{
				this.id = data.id
				console.log(data);
				this.getEditInfo()
			})
		},
		destroyed() {
			Bus.$off('edit')
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type) {
				let typeq = {
					type: type,
					typeone: ''
				}
				this.$emit('gettype', typeq)
			},
			getEditInfo(){
				this.ajax('get', '/api/pc/invoicehead/getEditInfo',{
					id:this.id
				},res => {
					if(res.status == 200){
						console.log(res.data);
						this.rise = {
							capacity:res.data.type,
							name: res.data.name,
							type:res.data.invoice_type,
							number:res.data.idcard,
							bank:res.data.bank,
							banknum:res.data.bank_number,
							address:res.data.bank_address,
							phone:res.data.bank_phone,
						}
						
					}else{
						
					}
				})
			},
			//提交
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  if(this.id == 0){
						  this.addground()
					  }else{
						  this.editground()
					  }
					
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
			  },
			//新建一个
			addground(){
				if(this.rise.capacity == 1){
					this.rise.type = 1
				}
				let data = {
					type:this.rise.capacity,
					name:this.rise.name,
					invoice_type:this.rise.type,
				}
				
				if(this.rise.capacity == 2){
					data.idcard = this.rise.number
					data.bank = this.rise.bank
					data.bank_number = this.rise.banknum
					data.bank_address = this.rise.address
					data.bank_phone = this.rise.phone
				}
				
				this.ajax('post', '/api/pc/invoicehead/add',data,res => {
					this.$message(res.msg);
				})
			},
			//编辑
			editground(){
				if(this.rise.capacity == 1){
					this.rise.type = 1
				}
				let data = {
					type:this.rise.capacity,
					name:this.rise.name,
					invoice_type:this.rise.type,
					id:this.id
				}
				if(this.rise.capacity == 2){
					data.idcard = this.rise.number
					data.bank = this.rise.bank
					data.bank_number = this.rise.banknum
					data.bank_address = this.rise.address
					data.bank_phone = this.rise.phone
				}
				this.ajax('post', '/api/invoicehead/edit',data,res => {
					this.$message(res.msg);
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.from{
		width: 921px;
		/* height: 878px; */
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		padding: 71px 126px 104px;
	}
	/deep/ .el-select{
		width: 100%;
	}
	/deep/ .el-input__inner{
		text-align: right;
		height: 54px;
	}
	/deep/ .el-button{
		width: 383px;
		height: 60px;
		// line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin-top: 70px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/invoice/add.vue